export default __webpack_public_path__ + "static/media/Sage's Braid of the Eldritch.fc8d6ed5.jpg";